window.onload = function(){
  var linkmsg=document.getElementById("linkmsg");
  linkmsg.innerHTML="";
  linkmsg.style.visibility="hidden";
  sizemsg.style.visibility="hidden";
  opmsg.style.visibility="hidden";
  haisen_position.style.display="none";
  panel_choice.style.display="none";
  op_psimsg.style.display="none";
	
//形状タイプ取得
    var idBoard = document.getElementsByName("shelfboard") ;
    var strBoard = "";
    for ( strBoard="", c=idBoard.length; c--; ) {
     if ( idBoard[c].checked ) {
      strBoard = idBoard[c].id ;
      break ;
     }
    }
	if(strBoard=="selectboard1"){
		document.area1.src = "https://image.rakuten.co.jp/atom-style/cabinet/searchseries/plusonetable/type_l/so-01.jpg";
		document.getElementById("board1").setAttribute("disabled", true);
		shelfboard1.style.color="lightgray";
 		document.getElementById("message").innerHTML = "<p>幅は最小40～最大150cm・奥行は最小25～最大90cm・高さ37～90cmまで1cm単位でオーダー可能です。<br>※高さ73cm～90cmは最小奥行40cm～となります。<br>※幅を超える奥行はオーダー不可です。<br>　</p>";
 	}
	else if(strBoard=="selectboard2"){
		document.area1.src = "https://image.rakuten.co.jp/atom-style/cabinet/searchseries/plusonetable/type_ko/so-01.jpg";
		document.getElementById("board1").removeAttribute("disabled");
		shelfboard1.style.color="black"; document.getElementById("message").innerHTML = "<p>幅は最小40～最大150cm・奥行は最小25～最大90cm・高さ37～90cmまで1cm単位でオーダー可能です。<br>※高さ73cm～90cmは最小奥行40cm～となります。<br>※幅を超える奥行はオーダー不可です。<br>※空間部の高さは内寸となります。生産工程上、5cm以上にてオーダー可能です。　</p>";
  }
}

// 画像・入力欄変更
function showimg1(){
	document.getElementById("board1").value = ""; //②コの字で空間部高さを入力しL字を選択しなおした時に内容削除
	document.area1.src = "https://image.rakuten.co.jp/atom-style/cabinet/searchseries/plusonetable/type_l/so-01.jpg";//①
	document.getElementById("board1").setAttribute("disabled", true);//③
	shelfboard1.style.color="lightgray";//④
	document.getElementById("message").innerHTML = "<p>幅は最小40～最大150cm・奥行は最小25～最大90cm・高さ37～90cmまで1cm単位でオーダー可能です。<br>※高さ73cm～90cmは最小奥行40cm～となります。<br>※幅を超える奥行はオーダー不可です。<br>　</p>";//⑤
  cartReset();
   changeMsg();
}

function showimg2(){
	document.area1.src = "https://image.rakuten.co.jp/atom-style/cabinet/searchseries/plusonetable/type_ko/so-01.jpg";
	document.getElementById("board1").removeAttribute("disabled");//⑦
	shelfboard1.style.color="black";//⑧
	document.getElementById("message").innerHTML = "<p>幅は最小40～最大150cm・奥行は最小25～最大90cm・高さ37～90cmまで1cm単位でオーダー可能です。<br>※高さ73cm～90cmは最小奥行40cm～となります。<br>※幅を超える奥行はオーダー不可です。<br>※空間部の高さは内寸となります。生産工程上、5cm以上にてオーダー可能です。　</p>";//⑨
  cartReset();
    changeMsg();
}

//カラー変更
function woodColor(changeImg){
  var imgSrc = $(document.area1).attr('src').split('/');
  switch(changeImg){
  	//木目
    case 0:var materialChange = $(document.area1).attr('src').replace(imgSrc[8] , "so-01");break;
    case 1:var materialChange = $(document.area1).attr('src').replace(imgSrc[8] , "so-02");break;
    case 2:var materialChange = $(document.area1).attr('src').replace(imgSrc[8] , "so-03");break;
    case 3:var materialChange = $(document.area1).attr('src').replace(imgSrc[8] , "so-04");break;
    case 4:var materialChange = $(document.area1).attr('src').replace(imgSrc[8] , "so-05");break;
    case 5:var materialChange = $(document.area1).attr('src').replace(imgSrc[8] , "so-06");break;
  	//メラミン
    case 6:var materialChange = $(document.area1).attr('src').replace(imgSrc[8] , "so-07");break;
    case 7:var materialChange = $(document.area1).attr('src').replace(imgSrc[8] , "so-08");break;
    case 8:var materialChange = $(document.area1).attr('src').replace(imgSrc[8] , "so-09");break;
    case 9:var materialChange = $(document.area1).attr('src').replace(imgSrc[8] , "so-10");break;
    case 10:var materialChange = $(document.area1).attr('src').replace(imgSrc[8] , "so-11");break;
    case 11:var materialChange = $(document.area1).attr('src').replace(imgSrc[8] , "so-12");break;
  	//突板
    case 12:var materialChange = $(document.area1).attr('src').replace(imgSrc[8] , "so-13");break;
    case 13:var materialChange = $(document.area1).attr('src').replace(imgSrc[8] , "so-14");break;
    case 14:var materialChange = $(document.area1).attr('src').replace(imgSrc[8] , "so-15");break;
    case 15:var materialChange = $(document.area1).attr('src').replace(imgSrc[8] , "so-16");break;
    case 16:var materialChange = $(document.area1).attr('src').replace(imgSrc[8] , "so-17");break;
  	//aino
    case 17:var materialChange = $(document.area1).attr('src').replace(imgSrc[8] , "so-18");break;
    case 18:var materialChange = $(document.area1).attr('src').replace(imgSrc[8] , "so-19");break;
    case 19:var materialChange = $(document.area1).attr('src').replace(imgSrc[8] , "so-20");break;
    case 20:var materialChange = $(document.area1).attr('src').replace(imgSrc[8] , "so-21");break;
    case 21:var materialChange = $(document.area1).attr('src').replace(imgSrc[8] , "so-22");break;
    case 22:var materialChange = $(document.area1).attr('src').replace(imgSrc[8] , "so-23");break;
  }
    $(document.area1).attr('src', materialChange+".jpg");
}

//オプション
function changeOp(){
    checkBoxhaisen = document.frm_detail.op_haisen.checked;
    checkBoxhole = document.frm_detail.op_concent.checked;
    checkBoxbk = document.frm_detail.op_casterbk.checked;
    checkBoxwh = document.frm_detail.op_casterwh.checked;
    opmsg.style.visibility="hidden";
    linkmsg.style.visibility="hidden";
  	haisen_position.style.display="none";
    panel_choice.style.display="none";
	
	if(checkBoxhole == false){
    opmsg.style.visibility="hidden";
    linkmsg.style.visibility="hidden";
  	haisen_position.style.display="none";
    panel_choice.style.display="none";
	var cancel = document.frm_detail.op_panel
    for (const i of cancel) {i.checked = false;}
	op_psimsg.style.display="none";
	}
//多いものから順に
//切欠き・穴・黒・白
	if (checkBoxhole==true&&checkBoxhaisen==true&&checkBoxbk==true&&checkBoxwh==true){
        document.getElementById("opmsg").innerHTML = "<p>配線切り欠きは天板中央への加工となります。</p><p>配線穴について、指定箇所が不可の場合や、詳細確認のためご連絡させていただく場合がございます。</p><p>※本体の高さに約5.2cmプラスとなります</p><p><span>ブラックとホワイトが選択されています</span></p>";
		opmsg.style.visibility="visible";
  		haisen_position.style.display="inline-block";
    	panel_choice.style.display="inline-block";     	
        cartReset();
        return false;
    }
//切欠き・穴・黒or白
    if (checkBoxhole==true&&checkBoxhaisen==true&&(checkBoxbk==true||checkBoxwh==true)){
        document.getElementById("opmsg").innerHTML = "<p>配線切り欠きは天板中央への加工となります。</p><p>配線穴について、指定箇所が不可の場合や、詳細確認のためご連絡させていただく場合がございます。</p><p>※本体の高さに約5.2cmプラスとなります</p>";
		opmsg.style.visibility="visible";
  		haisen_position.style.display="inline-block";
    	panel_choice.style.display="inline-block";     	
		cartReset();
        return false;
    }
//切欠き・黒・白
	if (checkBoxhaisen==true&&checkBoxbk==true&&checkBoxwh==true){
        document.getElementById("opmsg").innerHTML = "<p>配線切り欠きは天板中央への加工となります。</p><p>※本体の高さに約5.2cmプラスとなります</p><p><span>ブラックとホワイトが選択されています</span></p>";
		opmsg.style.visibility="visible";
        cartReset();
        return false;
    }
//切欠き・黒or白
    if (checkBoxhaisen==true&&(checkBoxbk==true||checkBoxwh==true)){
        document.getElementById("opmsg").innerHTML = "<p>配線切り欠きは天板中央への加工となります。</p><p>※本体の高さに約5.2cmプラスとなります</p>";
		opmsg.style.visibility="visible";
        cartReset();
        return false;
    }
//穴・黒・白
	if (checkBoxhole==true&&checkBoxbk==true&&checkBoxwh==true){
        document.getElementById("opmsg").innerHTML = "<p>配線穴について、指定箇所が不可の場合や、詳細確認のためご連絡させていただく場合がございます。</p><p>※本体の高さに約5.2cmプラスとなります</p><p><span>ブラックとホワイトが選択されています</span></p>";
		opmsg.style.visibility="visible";
  		haisen_position.style.display="inline-block";
    	panel_choice.style.display="inline-block";     	
		cartReset();
        return false;
    }
//穴・黒or白
    if (checkBoxhole==true&&(checkBoxbk==true||checkBoxwh==true)){
        document.getElementById("opmsg").innerHTML = "<p>配線穴について、指定箇所が不可の場合や、詳細確認のためご連絡させていただく場合がございます。</p><p>※本体の高さに約5.2cmプラスとなります</p>";
		opmsg.style.visibility="visible";
  		haisen_position.style.display="inline-block";
    	panel_choice.style.display="inline-block";     	
        cartReset();
        return false;
    }
//切欠き・穴
   if (checkBoxhole==true&&checkBoxhaisen==true){
        document.getElementById("opmsg").innerHTML = "<p>配線切り欠きは天板中央への加工となります。</p><p>配線穴について、指定箇所が不可の場合や、詳細確認のためご連絡させていただく場合がございます。</p>";
		opmsg.style.visibility="visible";
  		haisen_position.style.display="inline-block";
    	panel_choice.style.display="inline-block";     	
        cartReset();
        return false;
    }
//切欠き
    if (checkBoxhaisen==true){
        document.getElementById("opmsg").innerHTML = "<p>配線切り欠きは天板中央への加工となります。</p>";
		opmsg.style.visibility="visible";
        cartReset();
        return false;
    }
//配線穴
    if (checkBoxhole==true){
        document.getElementById("opmsg").innerHTML = "<p>配線穴について、指定箇所が不可の場合や、詳細確認のためご連絡させていただく場合がございます。</p>";
		opmsg.style.visibility="visible";
  		haisen_position.style.display="inline-block";
    	panel_choice.style.display="inline-block";     	
        cartReset();
        return false;
    }
//黒・白
	if (checkBoxbk==true&&checkBoxwh==true){
        document.getElementById("opmsg").innerHTML = "<p>※本体の高さに約5.2cmプラスとなります</p><p><span>ブラックとホワイトが選択されています</span></p>";
		opmsg.style.visibility="visible";
        cartReset();
        return false;
    }
//黒or白
    if (checkBoxbk==true||checkBoxwh==true){
        document.getElementById("opmsg").innerHTML = "<p>※本体の高さに約5.2cmプラスとなります</p>";
		opmsg.style.visibility="visible";
        cartReset();
        return false;
    }
	
	opmsg.style.visibility="hidden";
    cartReset();
}

function choicePanel(selectPanel){
  document.getElementById("op_positionL").value="";
  document.getElementById("op_positionU").value="";
  op_psimsg.style.display="inline-block";
  document.querySelector("#op_psimsg > p > span:nth-child(1)").innerHTML = "";
  switch(selectPanel){
    case 0:document.querySelector("#op_psimsg > p > span:nth-child(1)").innerHTML = "板面：Aを上から見て";break;
    case 1:document.querySelector("#op_psimsg > p > span:nth-child(1)").innerHTML = "板面：Bを側面から見て";break;
    case 2:document.querySelector("#op_psimsg > p > span:nth-child(1)").innerHTML = "板面：Cを側面から見て";break;
  }
  cartReset();
}


//カート中身リセット
function cartReset(){
  document.getElementById("price").value=""
  cart_price.innerHTML =""+" 円";
  cart_haba.innerHTML=""; 
  cart_depth.innerHTML=""; 
  cart_height.innerHTML="";
  cart_number.innerHTML="";
  cart_board1.innerHTML="";
  cart_color.innerHTML="";
  cart_option.innerHTML="";
  additional_fee.innerHTML="";
  linkmsg.style.visibility="hidden";
}


//リアルタイムサイズチェック
function changeMsg(){
    var intDepth=document.getElementById("depth").value;
    var intHaba=document.getElementById("haba").value;
    var intHeight=document.getElementById("height").value;
    var intBoard1=document.getElementById("board1").value;
    sizemsg.style.visibility="hidden";
//形状タイプ取得
    var idBoard = document.getElementsByName("shelfboard") ;
    var strBoard = "";
    for ( strBoard="", c=idBoard.length; c--; ) {
     if ( idBoard[c].checked ) {
      strBoard = idBoard[c].id ;
      break ;
     }
    }
    cartReset();
    if (intDepth==""||intHaba==""||intHeight==""){
        document.getElementById("sizemsg").innerHTML = "<p> </p>";
		sizemsg.style.visibility="hidden";
        return false;
    }
	
	//コの字タイプの場合
    if (strBoard == "selectboard2" ){
  var insideBoard1;
  var insideBoard2;
  insideBoard1=intHeight-12;
    if (intHeight <= 90 && intHeight-4 < intBoard1){
		document.getElementById("sizemsg").innerHTML = "<p>※ 高さ-4cm(厚み)を超える空間部高さはオーダー不可です ※</p>";
		sizemsg.style.visibility="visible";return false;
	}
    if (intBoard1 == ""){
		document.getElementById("sizemsg").innerHTML = "<p>※ 空間部高さを入力してください ※</p>";
		sizemsg.style.visibility="visible";return false;
	}
	if (intBoard1 < 5){
		document.getElementById("sizemsg").innerHTML = "<p>※ 空間部高さは5cm以上必要です ※</p>";
		sizemsg.style.visibility="visible";return false;
	}
   }

	//全体
     if (intHaba < 40 || intHaba > 150){
		 document.getElementById("sizemsg").innerHTML = "<p>※ 幅40cm未満・幅151cm以上はオーダー不可です ※</p>";
		 sizemsg.style.visibility="visible";return false;}
    if (intDepth < 25 || intDepth > 90){
		document.getElementById("sizemsg").innerHTML = "<p>※ 奥行25cm未満・奥行91cm以上はオーダー不可です ※</p>";
		sizemsg.style.visibility="visible";return false;}
    if (intHeight < 37 || intHeight > 90){
		document.getElementById("sizemsg").innerHTML = "<p>※ 高さ37cm未満・高さ91cm以上はオーダー不可です ※</p>";
		sizemsg.style.visibility="visible";return false;}
    if(intHaba!=intDepth && intHeight>72 && intDepth<40){
		document.getElementById("sizemsg").innerHTML = "<p>※ 高さ73cm以上の場合、奥行40cm未満はオーダー不可です ※</p>";
		sizemsg.style.visibility="visible";return false;}
    if (intHaba <= 89 && intHaba < intDepth){
		document.getElementById("sizemsg").innerHTML = "<p>※ 幅を超える奥行はオーダー不可です ※</p>";
		sizemsg.style.visibility="visible";return false;}
      document.getElementById("sizemsg").innerHTML = "<p> </p>"
	sizemsg.style.visibility="hidden";

}


// Plus One サイズオーダー
const strLink1="<a href=\"https://item.rakuten.co.jp/atom-style/"
const strLink2="\" target=\"_top\">→こちらのページよりお買い求めください。</a>"


function setGoods(url,haba,depth,height,color,board1,board2,price){
this.url=url;this.haba=haba;this.depth=depth;this.height=height;this.color=color;this.board1=board1;this.board2=board2;this.price=price;}
function searchURL(strHaba,strDepth,strHeight,strColor,numBoard1,numBoard2){
var strErr;
var intDepth=document.getElementById("depth").value
var intHaba=document.getElementById("haba").value
var intHeight=document.getElementById("height").value


//不可サイズチェック
if (intHaba < 40 || intHaba > 150){strErr="幅40cm未満・幅151cm以上はオーダー不可です。";}
else if (intDepth < 25 || intDepth > 90){strErr="奥行25cm未満・奥行91cm以上はオーダー不可です。";}
else if (intHeight < 37 || intHeight > 90){strErr="高さ37cm未満・高さ91cm以上はオーダー不可です。";}
else if (intHeight >= 73 && intDepth < 40){strErr="高さ73cm以上の場合、奥行40cm未満はオーダー不可です。";}
else if (intHaba <= 89 && intHaba < intDepth){strErr="幅を超える奥行はオーダー不可です。";}


//幅サイズ成形
if (strHaba.slice(-1)>=1 && strHaba.slice(-1)<=5){strHaba=strHaba.slice(0,strHaba.length-1) +"5";}
else if (strHaba.slice(-1)>=6 && strHaba.slice(-1)<=9){strHaba=parseInt(strHaba.slice(0,strHaba.length-1)) + 1 +"0";}

//奥行サイズ成形
if (strDepth.slice(-1)>=1 && strDepth.slice(-1)<=5){strDepth=strDepth.slice(0,strDepth.length-1) +"5";}
else if (strDepth.slice(-1)>=6 && strDepth.slice(-1)<=9){strDepth=parseInt(strDepth.slice(0,strDepth.length-1)) + 1 +"0";}

//高さサイズ成形
switch(intHeight != null){
  case intHeight <= 42: //高さ42cm以下のとき
    strHeight = "42";
    break;
  case intHeight <= 60: //高さ60cm以下のとき
    strHeight = "60";
    break;
  case intHeight <= 72: //高さ72cm以下のとき
    strHeight = "72";
    break;
  case intHeight <= 90: //高さ90cm以下のとき
    strHeight = "90";
    break;
}

//ベース価格
var basePriceA = [8000,10000,12000,20000]; //化粧紙・aino
var basePriceB = [19000,21000,31000,45000]; //nail・black
var basePriceC = [26000,30000,34000,58000]; //bp
var basePriceD = [21000,31000,40000,63000]; //mb・gs・ww
var basePriceE = [49000,51000,56000,76000]; //glandeA
var basePriceF = [54000,61000,66000,91000]; //glandeB
var basePriceG = [13000,16000,19000,29000]; //化粧紙・aino コの字タイプ用
var basePriceH = [19000,21000,31000,45000]; //nail・black コの字タイプ用
var basePriceI = [26000,30000,34000,58000]; //bp コの字タイプ用
var basePriceJ = [21000,31000,40000,63000]; //mb・gs・ww コの字タイプ用
var basePriceK = [49000,51000,56000,76000]; //glandeA コの字タイプ用
var basePriceL = [54000,61000,66000,91000]; //glandeB コの字タイプ用
var addPrice = [1000,2000,4000,5000,6000,7000,9000,12000,13000];//化粧・aino以外追加になったらチェック
var sellPrice;
var Column=(strHaba-40)/5;
var Row=(strDepth-25)/5;
	//形状タイプ取得
    var idBoard = document.getElementsByName("shelfboard") ;
    var strBoard = "";
    for ( strBoard="", c=idBoard.length; c--; ) {
     if ( idBoard[c].checked ) {
      strBoard = idBoard[c].id ;
      break ;
     }
    }
if(strBoard == "selectboard1")  //L字タイプの価格
  {
	if(strHeight == 42){//▼高さ37～42cm▼
    	if(strColor=="wood" || strColor=="aino"){sellPrice = basePriceA[0]+(Row*addPrice[1]);}
    	else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceB[0]+(Row*addPrice[2]);}
    	else if(strColor == "bp"){sellPrice = basePriceC[0]+(Row*addPrice[3]);}
    	else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceD[0]+(Row*addPrice[4]);}
    	else if(strColor == "glandeA"){sellPrice = basePriceE[0]+(Row*addPrice[2]);}
    	else if(strColor == "glandeB"){sellPrice = basePriceF[0]+(Row*addPrice[2]);}
  	}
	else if(strHeight == 60){//▼高さ43～60cm▼
    	if(strColor=="wood" || strColor=="aino"){sellPrice = basePriceA[1]+(Row*addPrice[1]);}
    	else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceB[1]+(Row*addPrice[3]);}
    	else if(strColor == "bp"){sellPrice = basePriceC[1]+(Row*addPrice[4]);}
    	else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceD[1]+(Row*addPrice[4]);}
    	else if(strColor == "glandeA"){sellPrice = basePriceE[1]+(Row*addPrice[3]);}
    	else if(strColor == "glandeB"){sellPrice = basePriceF[1]+(Row*addPrice[3]);}
  	}
	else if(strHeight == 72){//▼高さ61～72cm▼
    	if(strColor=="wood" || strColor=="aino"){sellPrice = basePriceA[2]+(Row*addPrice[1]);}
    	else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceB[2]+(Row*addPrice[3]);}
    	else if(strColor == "bp"){sellPrice = basePriceC[2]+(Row*addPrice[5]);}
    	else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceD[2]+(Row*addPrice[5]);}
    	else if(strColor == "glandeA"){sellPrice = basePriceE[2]+(Row*addPrice[3]);}
    	else if(strColor == "glandeB"){sellPrice = basePriceF[2]+(Row*addPrice[3]);}
  	}
	else if(strHeight == 90){//▼高さ73～90cm▼
    	Row = Row-3;
    	if(strColor=="wood" || strColor=="aino"){sellPrice = basePriceA[3]+(Row*addPrice[1]);}
    	else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceB[3]+(Row*addPrice[6]);}
    	else if(strColor == "bp"){sellPrice = basePriceC[3]+(Row*addPrice[7]);}
    	else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceD[3]+(Row*addPrice[8]);}
    	else if(strColor == "glandeA"){sellPrice = basePriceE[3]+(Row*addPrice[3]);}
    	else if(strColor == "glandeB"){sellPrice = basePriceF[3]+(Row*addPrice[3]);}
  	}
  	if(strColor == "wood" || strColor == "aino"){
    	if(strHaba <= 59){sellPrice = sellPrice+0;}
    	else if(strHaba <= 89){sellPrice = sellPrice+addPrice[1];}
    	else if(strHaba <= 119){sellPrice = sellPrice+(addPrice[1]*2);}
    	else if(strHaba <= 149){sellPrice = sellPrice+(addPrice[1]*3);}
    	else if(strHaba == 150){sellPrice = sellPrice+(addPrice[1]*4);}
  	}
  	if(strColor == "nail" || strColor == "black" || strColor == "bp" || strColor == "gs" || strColor == "mb" || strColor == "ww"){
    	if(strHaba <= 49){sellPrice = sellPrice+0;}
    	else if(strHaba <= 59){sellPrice = sellPrice+addPrice[1];}
    	else if(strHaba <= 69){sellPrice = sellPrice+(addPrice[1]*2);}
    	else if(strHaba <= 79){sellPrice = sellPrice+(addPrice[1]*3);}
    	else if(strHaba <= 89){sellPrice = sellPrice+(addPrice[1]*4);}
    	else if(strHaba <= 99){sellPrice = sellPrice+(addPrice[1]*5);}
    	else if(strHaba <= 109){sellPrice = sellPrice+(addPrice[1]*6);}
    	else if(strHaba <= 119){sellPrice = sellPrice+(addPrice[1]*7);}
    	else if(strHaba <= 129){sellPrice = sellPrice+(addPrice[1]*8);}
    	else if(strHaba <= 139){sellPrice = sellPrice+(addPrice[1]*9);}
    	else if(strHaba <= 149){sellPrice = sellPrice+(addPrice[1]*10);}
    	else if(strHaba == 150){sellPrice = sellPrice+(addPrice[1]*11);}
  	}
  	if(strColor == "glandeA" || strColor == "glandeB"){
		if(Column != 0){sellPrice = sellPrice+(Column*addPrice[0]);
		}
  	}
  	return sellPrice;
  }
else if(strBoard == "selectboard2")  //コ字タイプの価格
  {
	if(strHeight == 42){//▼高さ37～42cm▼
    	if(strColor=="wood" || strColor=="aino"){sellPrice = basePriceG[0]+(Row*addPrice[1]);}
    	else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceB[0]+(Row*addPrice[2]);}
    	else if(strColor == "bp"){sellPrice = basePriceC[0]+(Row*addPrice[3]);}
    	else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceD[0]+(Row*addPrice[4]);}
    	else if(strColor == "glandeA"){sellPrice = basePriceE[0]+(Row*addPrice[2]);}
    	else if(strColor == "glandeB"){sellPrice = basePriceF[0]+(Row*addPrice[2]);}
  	}
	else if(strHeight == 60){//▼高さ43～60cm▼
    	if(strColor=="wood" || strColor=="aino"){sellPrice = basePriceG[1]+(Row*addPrice[1]);}
    	else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceB[1]+(Row*addPrice[3]);}
    	else if(strColor == "bp"){sellPrice = basePriceC[1]+(Row*addPrice[4]);}
    	else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceD[1]+(Row*addPrice[4]);}
    	else if(strColor == "glandeA"){sellPrice = basePriceE[1]+(Row*addPrice[3]);}
    	else if(strColor == "glandeB"){sellPrice = basePriceF[1]+(Row*addPrice[3]);}
  	}
	else if(strHeight == 72){//▼高さ61～72cm▼
    	if(strColor=="wood" || strColor=="aino"){sellPrice = basePriceG[2]+(Row*addPrice[1]);}
    	else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceB[2]+(Row*addPrice[3]);}
    	else if(strColor == "bp"){sellPrice = basePriceC[2]+(Row*addPrice[5]);}
    	else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceD[2]+(Row*addPrice[5]);}
    	else if(strColor == "glandeA"){sellPrice = basePriceE[2]+(Row*addPrice[3]);}
    	else if(strColor == "glandeB"){sellPrice = basePriceF[2]+(Row*addPrice[3]);}
  	}
	else if(strHeight == 90){//▼高さ73～90cm▼
    	Row = Row-3;
    	if(strColor=="wood" || strColor=="aino"){sellPrice = basePriceG[3]+(Row*addPrice[1]);}
    	else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceB[3]+(Row*addPrice[6]);}
    	else if(strColor == "bp"){sellPrice = basePriceC[3]+(Row*addPrice[7]);}
    	else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceD[3]+(Row*addPrice[8]);}
    	else if(strColor == "glandeA"){sellPrice = basePriceE[3]+(Row*addPrice[3]);}
    	else if(strColor == "glandeB"){sellPrice = basePriceF[3]+(Row*addPrice[3]);}
  	}
  	if(strColor == "wood" || strColor == "aino"){
    	if(strHaba <= 59){sellPrice = sellPrice+0;}
    	else if(strHaba <= 89){sellPrice = sellPrice+addPrice[1];}
    	else if(strHaba <= 119){sellPrice = sellPrice+(addPrice[1]*2);}
    	else if(strHaba <= 149){sellPrice = sellPrice+(addPrice[1]*3);}
    	else if(strHaba == 150){sellPrice = sellPrice+(addPrice[1]*4);}
  	}
  	if(strColor == "nail" || strColor == "black" || strColor == "bp" || strColor == "gs" || strColor == "mb" || strColor == "ww"){
    	if(strHaba <= 49){sellPrice = sellPrice+0;}
    	else if(strHaba <= 59){sellPrice = sellPrice+addPrice[1];}
    	else if(strHaba <= 69){sellPrice = sellPrice+(addPrice[1]*2);}
    	else if(strHaba <= 79){sellPrice = sellPrice+(addPrice[1]*3);}
    	else if(strHaba <= 89){sellPrice = sellPrice+(addPrice[1]*4);}
    	else if(strHaba <= 99){sellPrice = sellPrice+(addPrice[1]*5);}
    	else if(strHaba <= 109){sellPrice = sellPrice+(addPrice[1]*6);}
    	else if(strHaba <= 119){sellPrice = sellPrice+(addPrice[1]*7);}
    	else if(strHaba <= 129){sellPrice = sellPrice+(addPrice[1]*8);}
    	else if(strHaba <= 139){sellPrice = sellPrice+(addPrice[1]*9);}
    	else if(strHaba <= 149){sellPrice = sellPrice+(addPrice[1]*10);}
    	else if(strHaba == 150){sellPrice = sellPrice+(addPrice[1]*11);}
  	}
  	if(strColor == "glandeA" || strColor == "glandeB"){
		if(Column != 0){sellPrice = sellPrice+(Column*addPrice[0]);}
  	}
	 	  //コの字の短い方の脚のため、高さに応じて追加される分の処理（10cm毎、25cm・35cm・45cm…)
  	if(strColor == "wood" || strColor == "aino"){
    	if(strDepth <= 34){sellPrice = sellPrice+0;}
    	else if(strDepth <= 44){sellPrice = sellPrice+addPrice[0];}
    	else if(strDepth <= 54){sellPrice = sellPrice+addPrice[0]*2;}
    	else if(strDepth <= 64){sellPrice = sellPrice+addPrice[0]*3;}
    	else if(strDepth <= 74){sellPrice = sellPrice+addPrice[0]*4;}
    	else if(strDepth <= 84){sellPrice = sellPrice+addPrice[0]*5;}
    	else if(strDepth == 90){sellPrice = sellPrice+addPrice[0]*6;}
  	}

  	return sellPrice;
  }	
	
}



/*リストから商品URLを取得*/
function checkURL(strHaba,strDepth,strHeight,strColor,numBoard1,numBoard2){
  for(var i in goods){
if(goods[i].haba==strHaba && goods[i].depth==strDepth && goods[i].height==strHeight && goods[i].color==strColor && goods[i].board1==numBoard1 && goods[i].board2==numBoard2){
return goods[i].url;}}
return false;
}

/*リストから価格を取得(201902追加)*/
function checkPrice(strHaba,strDepth,strHeight,strColor,numBoard1,numBoard2){
  for(var i in goods){
if(goods[i].haba==strHaba && goods[i].depth==strDepth && goods[i].height==strHeight && goods[i].color==strColor && goods[i].board1==numBoard1 && goods[i].board2==numBoard2){
return goods[i].price;}}
return false;
}


// 数値チェック
function isNumber(numVal){
  var pattern =/^([1-9]\d*|0)$/;
  return pattern.test(numVal);
}
/*価格算出ボタン押下時*/
function jump(){
cartReset();
    
var linkmsg=document.getElementById("linkmsg");
linkmsg.innerHTML="";
linkmsg.style.visibility="hidden";
var ErrMsg=document.getElementById("linkmsg");
ErrMsg.innerHTML="";
document.getElementById("price").value=""

var strDepth=document.getElementById("depth").value;
var strHaba=document.getElementById("haba").value;
var strHeight=document.getElementById("height").value;
var strBoardheight1=document.getElementById("board1").value;
var idOption = document.getElementsByName("option") ;
var idColor = document.getElementsByName("colortype") ;
var idBoard = document.getElementsByName("shelfboard") ;
var strColor = "";
var strBoard = "";
var strOption = "";
var i=0;
var c=0;

//カラー取得
for ( strColor="", i=idColor.length; i--; ) {
if ( idColor[i].checked ) {
     if( idColor[i].id.slice(0,4)=="wood" ){
         strColor = idColor[i].id.slice(0,4);
     }else if( idColor[i].id.slice(0,4)=="aino" ){
         strColor = idColor[i].id.slice(0,4);
	 }else if( idColor[i].id.slice(0,7)=="glandeA" ){
         strColor = idColor[i].id.slice(0,7);
     }else if( idColor[i].id.slice(0,7)=="glandeB" ){
         strColor = idColor[i].id.slice(0,7);
     }else {strColor = idColor[i].id;}
  var valueColor = idColor[i].value ;
  break ;
 }
}

//形状タイプ取得
for ( strBoard="", c=idBoard.length; c--; ) {
 if ( idBoard[c].checked ) {
  strBoard = idBoard[c].id ;
  var valueBoard = idBoard[c].value ;
  break ;
 }
}
	
//オプション取得部分
var total = 0;	//オプション何個選択しているか入れる変数
var panel_ichi = "";	//パネル選択した位置入れる変数
var valueOption = "";	//配線切り欠きや配線穴などのvalue値を入れる変数
var op_positionL = document.getElementById("op_positionL").value;	//左から●cmの入力値取得
var op_positionU = document.getElementById("op_positionU").value;	//下から●cmの入力値取得
for ( c = 0; c < idOption.length; c++ ){
	if ( idOption[c].checked ) {
     total++;
		if( strOption == "" ) {
         strOption = idOption[c].id;
         var valueOption = idOption[c].value;
     	
			if( strOption == "op_concent" ) {
         	hole_ichi(panel_ichi,op_positionL,op_positionU);
		 	var valueOption = "配線穴(" + panel_ichi +")" ;
  	 		}
		}
		else if( idOption[c].id == "op_concent" ) {
         hole_ichi(panel_ichi,op_positionL,op_positionU);
         var valueOption = valueOption +"、配線穴(" + panel_ichi +")" ;
  	 	}
		else if( strOption != "" ) {
         var valueOption = valueOption+"、"+idOption[c].value;
     	}
	}
  }
//オプションの単価
 if(total>0){
     total=total*2000;
 }
	
function hole_ichi(){
  var op_position = document.querySelector("#op_psimsg > p > span:nth-child(1)").innerHTML;	//HTML要素を取得
  switch(op_position){
    case "板面：Aを上から見て":op_position = "天板";break;
    case "板面：Bを側面から見て":op_position = "左側板";break;
    case "板面：Cを側面から見て":op_position = "右側板";break;
  }
	panel_ichi = op_position+"の左から"+op_positionL+"×下から"+op_positionU+"cmに配線穴中央が来る配置";
}
	
if(typeof valueOption=== "undefined"){
     valueOption="オプション無し";
 }

if (isNumber(strHaba)==false){
alert("幅は『1以上の整数(小数点不可/半角文字）』をご入力ください。");
return false;
}
if (isNumber(strDepth)==false){
alert("奥行は『1以上の整数(小数点不可/半角文字）』をご入力ください");
return false;
}
if (isNumber(strHeight)==false){
alert("高さは『1以上の整数(小数点不可/半角文字）』をご入力ください");
return false;
}
/*if (isNumber(strBoardheight1)==false){
alert("空間部高さは『1以上の整数(小数点不可/半角文字）』をご入力ください");
return false;
}*/

if (valueOption.indexOf("キャスター白(2個)、キャスター黒(2個)")!== -1){
alert("キャスターはブラックとホワイトのどちらかをお選びください。");
return false;
}

if (strColor==false){
alert("カラーを選択してください");
return false;
}
	
//配線穴の入力チェック
var checkBoxhole = document.frm_detail.op_concent.checked;
if(checkBoxhole==true){
  if(valueOption=="オプション無し"){alert("配線穴の位置を『板面A～D』から選択してください");return false;}
  if(op_positionL==""){alert("配線穴の位置指定は『1以上の整数(小数点不可/半角文字）』をご入力ください");return false;}
  if(op_positionU==""){alert("配線穴の位置指定は『1以上の整数(小数点不可/半角文字）』をご入力ください");return false;}
}

//L字タイプの場合の空間部高さ「なし」の処理
if(valueBoard=="コの字タイプ"){
  var numBoard1 = strBoardheight1;
  var numBoard2 = "0";
  strBoardheight1 = strBoardheight1+"cm";
  strBoardheight2="なし";
}else if(valueBoard=="L字タイプ"){
  var numBoard1 = "0";
  var numBoard2 = "0";
  strBoardheight1="なし";
  strBoardheight2="なし";
}
	

	
//上月と大阪判定 後に福井の可能性あり　※モーダルウィンドウの各Value値へ

if( strColor=="glandeA" | strColor=="glandeB" ){  //上月ページ5555a00035
  document.getElementById("item_id").value="10046998";  //RAC番号
  document.getElementById("inventory_id").value="84974";  //項目選択肢固有番号
}else {  //大阪ページ5555a00034
  document.getElementById("item_id").value="10046997"; //RAC番号
  document.getElementById("inventory_id").value="84973";  //項目選択肢固有番号
}


document.getElementById("choice1").value=strHaba+"cm"
document.getElementById("choice2").value=strDepth+"cm"
document.getElementById("choice3").value=strHeight+"cm"
document.getElementById("choice4").value=valueBoard
document.getElementById("choice5").value=strBoardheight1
document.getElementById("choice6").value=valueColor
document.getElementById("choice7").value=valueOption
document.getElementById("choice9").value=total
//商品ページの有無チェック
var comcode=checkURL(strHaba,strDepth,strHeight,strColor,numBoard1,numBoard2);
if (!comcode=="" && valueOption=="オプション無し" && strColor!="kme" && valueColor!=="オーク"){
var target=document.getElementById("linkmsg");
linkmsg.style.visibility="visible";
target.innerHTML="ご希望サイズは既製品がございます。<br>"+strLink1+comcode+"/"+strLink2;
return false;
}
if (!comcode=="" && valueOption=="オプション無し" && strColor!="kme" && valueColor=="オーク"){
var target=document.getElementById("linkmsg");
linkmsg.style.visibility="visible";
target.innerHTML="化粧紙の木目タイプオークは別注色のため金額が異なります。";
}

var url=searchURL(strHaba,strDepth,strHeight,strColor,numBoard1,numBoard2);

if(!url){
alert("サイズを入力してください");
return false;
}
//20191122追加
var strVisible=sizemsg.style.visibility;
if(document.getElementById("sizemsg").innerHTML == "<p>※ 棚板なしの高さ90cm以上をご希望の場合は、ボンドでの固定と壁付けにて設置でのご使用をお願いいたします ※</p>"){
    
}else if(strVisible!="hidden"){
alert("サイズの確認をお願いします");
return false;
}
if(!comcode=="" && valueOption!="オプション無し" && strColor!="kme"){
url=checkPrice(strHaba,strDepth,strHeight,strColor,numBoard1,numBoard2);
}
//var strCode=url.substr(url.lastIndexOf("/"));
//url=url.replace(strCode,"");
//strCode="/"+strCode.substring(4,11)

var intUnit;
if (isNaN(url)==false){
 intUnit=(parseInt(url)+total)/1000;
 document.getElementById("price").value =(parseInt(url)+total).toLocaleString()+" 円";
 cart_price.innerHTML =(parseInt(url)+total).toLocaleString()+" 円";
 cart_haba.innerHTML=strHaba;
 cart_depth.innerHTML=strDepth;
 cart_height.innerHTML=strHeight;
 cart_number.innerHTML=valueBoard;
 cart_board1.innerHTML=strBoardheight1;
 cart_color.innerHTML=valueColor;
 cart_option.innerHTML=valueOption;
 additional_fee.innerHTML=total;}
else if(isNaN(url)==true) {
linkmsg.style.visibility="visible";
 ErrMsg.innerHTML=url;
 intUnit=""
}
document.getElementById("units").value=intUnit;
document.getElementById("choice8").value="見積もり金額："+(parseInt(url)+total);
return false;
}

function checkText() {
 var choice1=document.frm.choice1.value;
 var choice2=document.frm.choice2.value;
 var choice3=document.frm.choice3.value;  
 var choice4=document.frm.choice4.value;
 var choice5=document.frm.choice5.value;  
 var choice6=document.frm.choice6.value;  
 var choice7=document.frm.choice7.value;
 var choice9=document.frm.choice9.value;  var text = document.frm.inventory_id.value;
 var price = document.frm_detail.price.value;
 if(choice1=="" || choice2=="" || choice3=="" || choice5=="" ) {
     alert("ご希望のサイズを正しく入力後、価格算出ボタンを押してください。");
     return false;
 }
 if(price=="") {
     alert("価格が算出されていません。既製品がある場合、「この条件で金額算出」ボタン下の該当商品ページよりお買い求めください。");
     return false;
 }       
 return true;
}

//使ってない？
goods = new Object();
goods[0] =new setGoods("未登録","*w","*d","*h","thick","glandeA_tm","空間h","0","price");
goods[1] =new setGoods("未登録","*0","*0","*0","40","glandeA_mp","13","0","price");
goods[2] =new setGoods("未登録","*0","*0","*0","40","glandeA_wn","13","0","price");
goods[3] =new setGoods("未登録","*0","*0","*0","40","glandeB_tmgy","13","0","price");
goods[4] =new setGoods("未登録","*0","*0","*0","40","glandeB_tmbk","13","0","price");
goods[5] =new setGoods("未登録","0","0","0","40","wood","13","0","price");
goods[6] =new setGoods("未登録","0","0","0","40","aino","13","0","price");
goods[7] =new setGoods("未登録","0","0","0","40","nail","32","32","price");
goods[8] =new setGoods("未登録","0","0","0","40","black","13","0","price");
goods[9] =new setGoods("未登録","0","0","0","40","bp","13","0","price");
goods[10] =new setGoods("未登録","0","0","0","40","mb","13","0","price");
goods[11] =new setGoods("未登録","0","0","0","40","gs","13","0","price");
goods[12] =new setGoods("未登録","0","0","0","40","ww","13","0","price");
goods[13] =new setGoods("未登録","*0","*0","*0","40","glandeA_tm","13","0","price");
goods[14] =new setGoods("未登録","*0","*0","*0","40","glandeA_mp","13","0","price");
goods[15] =new setGoods("未登録","*0","*0","*0","40","glandeA_wn","13","0","price");
goods[16] =new setGoods("未登録","*0","*0","*0","40","glandeB_tmgy","13","0","price");
goods[17] =new setGoods("未登録","*0","*0","*0","40","glandeB_tmbk","13","0","price");

